import { generateUniqueId } from "@/utils/utils";

class WebSocketService {
  constructor(url) {
    this.id = generateUniqueId();
    this.url = url;
    this.socket = null;
    this.isConnected = false;
    this.listeners = [];

    // this is for custom events
    this.events = {};
  }

  // Register an event listener
  on(eventName, callback) {
    if (!this.events[eventName]) this.events[eventName] = [];
    this.events[eventName].push(callback);
  }

  // Emit an event with optional data
  emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach((cb) => cb(data));
    }
  }

  connect() {
    if (this.socket) {
      console.warn("WebSocket already connected");
      return;
    }

    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      this.isConnected = true;
      this.emit("connected", this.isConnected);
      console.log("Websocket connected!");
    };

    this.socket.onclose = (event) => {
      console.log("Websocket close reason:", event.reason);
      if (event.code !== 1000) {
        console.error("Websocket closed unexpectedly:", event);
        this.emit("error", event);
      }
      if (this.socket) {
        // emit disconnected event,
        // clears higher level variables first
        this.emit("disconnected", false);
        // remove event listeners
        this.removeAllListeners();

        // clear class level variables
        this.socket = null;
        this.isConnected = false;
        console.log("Websocket connection closed");
      }
    };

    this.socket.onerror = (error) => {
      console.error("Websocket error: ", error);
    };

    // gets the message and passes into the array of listeners
    // used so multiple components can access the same data
    this.socket.onmessage = (event) => {
      console.log("Message received: ", JSON.parse(event.data));
      this.listeners.forEach((callback) => callback(event.data));
    };
  }

  send(message) {
    if (!this.isConnected) {
      console.error("WebSocket is not connected.");
      return;
    }

    this.socket.send(message);
    console.log("Message sent: ", message);
  }

  //   write custom listeners
  addListener(callback) {
    if (typeof callback === "function") {
      const wrapper = (data) => {
        if (!this.isConnected) {
          console.error("Websocket is not connected. Message not received");
          return;
        }

        callback(data);
      };
      this.listeners.push(wrapper);
    } else {
      console.error("Listener must be a function");
    }
  }

  // Remove event listeners
  removeAllListeners() {
    if (this.socket) {
      // Remove native WebSocket event handlers
      this.socket.onopen = null;
      this.socket.onclose = null;
      this.socket.onerror = null;
      this.socket.onmessage = null;
    }

    // Clear custom event system
    this.events = {};

    // Clear message listeners
    this.listeners = [];
    console.log("All Listeners removed!");
  }

  close() {
    if (this.socket) {
      this.socket.close();
    }
  }
}

export default WebSocketService;
